module.exports = __webpack_public_path__ + "img/spinner_loading.08a3fc26.gif";